import React, { useState } from 'react'
import axios from 'axios'
import { ADDRESSES, PaddyPDFFolder } from '../routes/addresses'
import { useEffect } from 'react'
import { BASE_URL } from "../routes/config";
import statistic from "../Assets/images/statistic.png";
import { PieChart } from '@mui/x-charts/PieChart';
import useFetchFinancePaddy from '../Hooks/API/useFetchFinancePaddy';

function Procurement(
  {
    wordCount
  }
) {
  const { getPageData, loading } = useFetchFinancePaddy('/Wapi/paddylst');

  // const fetchdata = ()=>{

  //   axios.post(`${BASE_URL}/wapi/getdoclist`,
  //  {
  //    auth_key:"xxxxx",
  //    doc_type: 3
  //  }
  //  // ,
  //  // {
  //  //     headers: {
  //  //         Authorization: loginData.token,
  //  //     },
  //  // }
  //  ).then(res => {

  //   if(res.status == '200'){

  //      if(res.data.suc > 0){
  //       setProcurementData(res?.data?.msg);
  //         //  setPageTitle(res.data.title);
  //         //  setFolderLocation(res?.data?.folder_name)
  //          // setFolderLocation()
  //         //  console.log(res , 'uuuuuuuuuuuuuuuuuuuuuu', res?.data?.msg);

  //          // pageDataCheck = res.data.status;
  //      } else {
  //       //  setPageData([0])
  //        setProcurementData([0])
  //        // pageDataCheck = res.data.status;
  //      }

  //      }

  //  }) 

  // }

  // function limitWords(content, wordLimit) {
  //   const words = content?.split(' ');
  //   if (words.length > wordLimit) {
  //     return words.slice(0, wordLimit).join(' ') + '...';
  //   }
  //   return content;
  // }





  // const gstSettings = await handleGetGst();

  return (
    <>
      <div className="statistic">
        <div className="statistic_left">
          <ul className='financeData'>
            {!loading && getPageData?.length > 0 ? (
              getPageData.map((item, index) => (
                <li key={index}>
                  {item?.subject}
                  <span><a href={BASE_URL + '/' + PaddyPDFFolder + item?.file_name} target='_blank' rel="noreferrer">
                    <i class="fa fa-file-pdf-o" aria-hidden="true"></i>  Download
                  </a></span>
                </li>
              ))
            ) : (
              <li>Loading data...</li>
            )}

          </ul>
        </div>


      </div>
    </>
  )
}

export default Procurement